import { Injectable } from '@angular/core';
import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import type { HttpEvent } from '@angular/common/http';
import { Router } from '@angular/router';
import {
  catchError,
  Observable,
  throwError,
} from 'rxjs';

import { AuthService } from '../auth/auth.service';
import { GlobalsessionhandlerService } from 'src/app/shared/services/globalsessionhandler.service';
import { SurveyUrlService } from 'src/app/survey-url/survey-url.service';
import { CookieService } from 'ngx-cookie-service';
import { SiteminderAuthService } from './oidc-config.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInterceptorServices
  implements HttpInterceptor
{
  constructor(
    private authService: AuthService,
    private sessionHandlerService: GlobalsessionhandlerService,
    private surveyUrlService: SurveyUrlService,
    private cookieService: CookieService,
    private siteminderService: SiteminderAuthService,
    private router: Router
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    try {
      const idtoken =
        this.siteminderService.getValidIdToken() ||
        sessionStorage.getItem('siteminderIdToken') ||
        sessionStorage.getItem('id_token');

      const validToken =
        idtoken &&
        idtoken !== 'null' &&
        idtoken !== 'undefined';

      if (
        req.url.startsWith(environment.baseUrl) &&
        validToken
      ) {
        req = req.clone({
          setHeaders: {
            Authorization:
              `Bearer ${idtoken}`,
            authProvider:
              environment.authProvider,
          },
        });
      }

      return next.handle(req).pipe(
        catchError((error) => {
          this.logError(
            'HTTP request failed',
            error
          );

          if (error?.status === 401) {
            try {
              this.siteminderService.logout();
            } catch (logoutError) {
              this.logError(
                'SiteMinder logout failed',
                logoutError
              );

              try {
                this.router.navigate([
                  '/login',
                ]);
              } catch (
                navigationError
              ) {
                this.logError(
                  'Login redirect failed',
                  navigationError
                );
              }
            }
          }

          return throwError(
            () => error
          );
        })
      );
    } catch (error) {
      this.logError(
        'Token interceptor failed',
        error
      );

      return next.handle(req).pipe(
        catchError(
          (requestError) => {
            this.logError(
              'HTTP request failed',
              requestError
            );

            if (
              requestError?.status ===
              401
            ) {
              try {
                this.siteminderService.logout();
              } catch (
                logoutError
              ) {
                this.logError(
                  'SiteMinder logout failed',
                  logoutError
                );

                try {
                  this.router.navigate([
                    '/login',
                  ]);
                } catch (
                  navigationError
                ) {
                  this.logError(
                    'Login redirect failed',
                    navigationError
                  );
                }
              }
            }

            return throwError(
              () => requestError
            );
          }
        )
      );
    }
  }

  private logError(
    context: string,
    error: unknown
  ): void {
    try {
      const messages: string[] = [];
      let currentError: unknown =
        error;
      let depth = 0;

      while (
        currentError &&
        depth < 5
      ) {
        if (
          currentError instanceof Error
        ) {
          messages.push(
            currentError.message ||
              currentError.name
          );

          const nestedError =
            currentError as Error & {
              cause?: unknown;
              innerException?: unknown;
              innerError?: unknown;
            };

          currentError =
            nestedError.cause ??
            nestedError.innerException ??
            nestedError.innerError ??
            null;
        } else {
          messages.push(
            'Unknown error'
          );

          currentError = null;
        }

        depth++;
      }

      console.error(
        `${context}${
          messages.length
            ? `: ${messages.join(
                ' | '
              )}`
            : ''
        }`
      );
    } catch {
      console.error(context);
    }
  }
}